<template>
  <view-wrapper
    prefix="Add new"
    name="Label"
    path="labels"
    :showCancel="true"
    addedText="Add label"
    :addedFunc="createLabel"
    :hasChangesBeenMade="hasChangesBeenMade"
    :validation="validation"
    :loading="loading"
  >
    <wrapper class="mb-4" v-if="standardLabels && standardLabels.length > 0">
      <div>
        <p class="mt-0">Create from a label template</p>
        <div class="w-64">
          <drop-down
            class="flex-1 w-full mr-2"
            placeholder="Select label template"
            :value="standardLabelTemplate"
            valueProperty="name"
            searchProp="name"
            :options="standardLabels"
            @input="setStandardLabelTemplate($event)"
          >
          </drop-down>
        </div>
      </div>
      <div>
        <grafokett-button
          class="flex items-center justify-center w-40 px-3 py-2 mt-4 primary"
          @click="createFromTemplate"
          v-if="standardLabelTemplate && standardLabelTemplate.id"
        >
          Create
        </grafokett-button>
      </div>
    </wrapper>

    <center
      v-if="
        standardLabels &&
          standardLabels.length > 0 &&
          features &&
          features.subscriptionType &&
          features.subscriptionType !== 'Free'
      "
    >
      <p>- or -</p>
    </center>

    <wrapper
      class="mb-4"
      v-if="
        !data.variables &&
          features &&
          features.subscriptionType &&
          features.subscriptionType !== 'Free'
      "
    >
      <div>
        <div class="relative py-40" v-if="!file">
          <div class="absolute inset-0 flex flex-col p-4">
            <p class="mt-0">Upload file (.nlbl)</p>
            <Dropzone
              :multiple="false"
              @filesAdded="onFilesAdded"
              accept=".nlbl"
            >
              Add file
            </Dropzone>
          </div>
        </div>
        <div class="p-4 rounded bg-primary-light" v-else>
          <span>{{ file.name }}</span>
          <grafokett-button
            class="float-right small"
            @click="
              () => {
                data = {};
                file = undefined;
              }
            "
            >Change file</grafokett-button
          >
        </div>
        <grafokett-button
          class="flex content-center w-40 mt-4 light"
          @click="uploadFiles"
          v-if="file"
        >
          <i class="p-1 upload-symbol" />
          <span class="flex-1 inline-block p-1 text-white">Upload</span>
        </grafokett-button>
      </div>
    </wrapper>

    <div
      v-else-if="
        features &&
          features.subscriptionType &&
          features.subscriptionType !== 'Free'
      "
    >
      <wrapper class="relative mb-4" :focus="true">
        <p class="mt-0">Uploaded file</p>
        <div class="p-4 rounded bg-primary-light">
          {{ file.name }}
        </div>
        <div class="flex content-center mt-4">
          <grafokett-button
            class="flex content-center w-56 primary"
            @click="
              () => {
                data = {};
                file = undefined;
              }
            "
          >
            <i class="p-1 upload-symbol" />
            <span class="flex-1 inline-block p-1 text-darkendtextcolor"
              >Upload new file</span
            >
          </grafokett-button>
          <i class="p-2 mx-4 my-auto user-symbol" />
          <p class="flex-1 w-48 my-auto italic">
            Uploading a new file will delete the old one and the rest of the
            preferences.
          </p>
        </div>
        <div>
          <p class="mt-12 ml-4 text-2xl">Variables</p>
          <div class="ml-8">
            <p v-for="(variable, index) in data.variables" :key="index">
              {{ variable.name }}
            </p>
          </div>
        </div>
      </wrapper>

      <wrapper
        :checkForChildFocused="true"
        class="p-5 pt-10 mb-3"
        :focus="labelname !== ''"
      >
        <grafokett-input
          class="w-96"
          v-model="labelname"
          labelPlaceholder="Label name"
        />
      </wrapper>
    </div>
  </view-wrapper>
</template>

<script>
import GrafokettButton from "../components/forms/Button.vue";
import GrafokettInput from "../components/forms/Input.vue";
import DropDown from "../components/forms/DropDown.vue";
import Dropzone from "../components/Dropzone";

export default {
  components: {
    GrafokettButton,
    GrafokettInput,
    DropDown,
    Dropzone
  },
  data() {
    return {
      showPopUp: false,
      selected: {},
      labelname: "",
      file: undefined,
      uploadProgress: {},
      uploading: false,
      options: [],
      successfullUploaded: false,
      data: {},
      parentGroup: [],
      groups: [],
      standardLabelTemplate: null,
      headersGroup: {
        groupName: "Group name"
      },
      loading: false
    };
  },
  async mounted() {
    this.loading = true;

    if (!this.$store.getters["FEATURES/FEATURES"])
      await this.$store.dispatch("FEATURES/GET_FEATURES");

    await this.$store.dispatch("LABELS/GET_STANDARD_LABEL_TEMPLATES");

    await this.$store.dispatch("GROUPS/GET_AVAILABLE_GROUPS");
    this.groups = this.$store.getters["GROUPS/GROUPS"];
    this.loading = false;
  },
  computed: {
    bindingOptions() {
      if (!this.data[0] || !this.data[0].variables) {
        return [];
      }

      return this.data[0].variables;
    },
    standardLabels() {
      return this.$store.getters["LABELS/STANDARD_LABEL_TEMPLATES"];
    },
    features() {
      return this.$store.getters["FEATURES/FEATURES"];
    }
  },
  methods: {
    validation() {
      return (
        this.labelname !== "" && this.data.variables && this.data.label !== ""
      );
    },
    hasChangesBeenMade() {
      return this.file !== undefined;
    },
    getBoundVariable(variable) {
      if (!this.data[0] || !this.data[0].variables) {
        return null;
      }

      return this.data[0].variables.find(
        v => v.variableId === variable.bindingVariableId
      );
    },
    updateBoundVariable(input, variable) {
      variable.bindingVariableId = input.variableId;
      variable.bindingVariableName = input.variableName;
    },
    cancel() {
      this.showPopUp = true;
    },
    onFilesAdded(file) {
      this.file = file;
    },
    async uploadFiles() {
      try {
        this.loading = true;
        const formData = new FormData();
        formData.append("labelFile", this.file);
        const data = await this.$store.dispatch(
          "DATA/READ_LABEL_VARIABLES_AND_PROPERTIES",
          formData
        );
        const selected = {};
        this.options = data.variables.map(e => {
          selected[e.name] = e.name;
          e.locked = false;
          return e.name;
        });
        this.data = data;
        this.selected = selected;
        this.successfullUploaded = true;
        this.labelname = this.file.name;
        this.loading = false;
      } catch (e) {
        console.log(e);
        this.uploading = false;
        // Just do this for now...
        this.successfullUploaded = true;
        this.loading = false;
      }
    },
    setStandardLabelTemplate(input) {
      this.standardLabelTemplate = input;
    },
    async createFromTemplate() {
      var payload = {
        ...this.standardLabelTemplate
      };
      const response = await this.$store.dispatch(
        "LABELS/CREATE_FROM_STANDARD_LABEL",
        payload
      );
      this.$router.push(`/labels/${response.label.id}`);
    },
    async createLabel() {
      var payload = {
        name: this.labelname,
        label: this.data.label,
        variables: this.data.variables
      };

      try {
        this.loading = true;
        const response = await this.$store.dispatch(
          "LABELS/ADD_GROUPS_TO_LABEL",
          payload
        );
        this.$router.push({ path: "/labels/" + response.data.entityId });
        this.loading = false;
      } catch {
        this.loading = false;
      }
    }
  }
};
</script>
